<template>
    <div v-if="isVisible" className="fixed-overlay fixed-overlay__modal">
        <div className="modal">
            <div className="modal_container">
                <h5>{{title}}</h5>
                <p>{{message}}</p>
                <div className="btn_container">
                    <button class="btn btn-sm btn-success text-uppercase"
                    @click="actionAndcloseModal">Да
                </button>
                <div className="modal_separator"> </div>
                    <button class="btn btn-sm btn-success text-uppercase"
                    @click="closeModal">Нет
                </button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    export default {
    props: {
    title: {
    type: String,
            default: 'Предупреждение'
        },
        message: {
            type: String,
            default: ''
        },
        isVisible: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
    actionAndcloseModal() {
    this.$emit('action');
}
    }
}
</script>

<style scoped>
.fixed-overlay {
    position: fixed;
    overflow: auto;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
}
.modal {
    position: absolute;
    left: 50%;
    top: 60%;
    transform: translate(-50%, -50%);
    display: block;
}
.modal_container {
    padding: 20px;
    background-color: #fff;
    color: #000;
}
.btn_container{
    display: flex;
    justify-content: center;
    align-items: center;
}
.modal_separator{
    width: 10px;
}
.modal .btn-danger, .modal .btn-success {
    border-radius: 100px;
}
.btn_container .btn{
    width: 100px;
}

</style>